import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPUkraineRequestData } from "@/src/types/admissionOffice";

const AOPUkraineRequestLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPUkraineRequestData>({
    whose_doc: "",
    currentDate: "",
    fullName: "",
    fullNameEn: "",
    dateOfBirth: "",
    passportNumber: "",
    withPrint: false,
    bodyPV: [],
    documentNumber: "",
    secondBody: [],
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPUkraineRequestData>({
    whose_doc: "",
    currentDate: "",
    fullName: "",
    fullNameEn: "",
    dateOfBirth: "",
    passportNumber: "",
    withPrint: false,
    bodyPV: [],
    documentNumber: "",
    secondBody: [],
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig dataForGeneration={dataForGeneration} setDataForGeneration={setDataForGeneration} setBodyForPrev={setBodyForPrev} />
        <AOPPrev bodyForPrev={bodyForPrev} />
      </div>
    </>
  );
};

export default AOPUkraineRequestLayout;
